import { analytics } from "../utils/mixpanel";
import { useCallback } from "react";

// Custom hook for using Mixpanel analytics
export const useMixpanel = () => {
  const track = useCallback(
    (eventName: string, properties?: Record<string, unknown>) => {
      analytics.track(eventName, properties);
    },
    [],
  );

  const identify = useCallback((userId: string) => {
    analytics.identify(userId);
  }, []);

  const setUserProperties = useCallback(
    (properties: Record<string, unknown>) => {
      analytics.setUserProperties(properties);
    },
    [],
  );

  const trackPageView = useCallback(
    (pageName: string, properties?: Record<string, unknown>) => {
      analytics.trackPageView(pageName, properties);
    },
    [],
  );

  const setSuperProperties = useCallback(
    (properties: Record<string, unknown>) => {
      analytics.setSuperProperties(properties);
    },
    [],
  );

  const alias = useCallback((alias: string) => {
    analytics.alias(alias);
  }, []);

  const reset = useCallback(() => {
    analytics.reset();
  }, []);

  const getStatus = useCallback(() => {
    return analytics.getStatus();
  }, []);

  const testTrack = useCallback(() => {
    return analytics.testTrack();
  }, []);

  const trackUTMCampaign = useCallback(
    (campaignName: string, additionalProperties?: Record<string, unknown>) => {
      analytics.trackUTMCampaign(campaignName, additionalProperties);
    },
    [],
  );

  return {
    track,
    identify,
    setUserProperties,
    trackPageView,
    setSuperProperties,
    alias,
    reset,
    getStatus,
    testTrack,
    trackUTMCampaign,
  };
};
